/**
 * Knobs do jogo. A tela de opções escreve aqui; o mixer só lê.
 * Persistido em localStorage — não é segredo, só preferência de volume.
 */
const KEY = 'uoidle.audio';

/** Os volumes por tipo (docs/proposta-sons.md §07), além do Geral. */
export type CanalAudio = 'skills' | 'combate' | 'criaturas' | 'passos' | 'ambiente';
const CANAIS: readonly CanalAudio[] = ['skills', 'combate', 'criaturas', 'passos', 'ambiente'];

export const AUDIO = {
  muted: false,
  /** Quem joga pela primeira vez entra com o Geral na metade e sobe se quiser (techspec-hud-v3 §24). */
  master: 0.5,
  skills: 1,
  combate: 1,
  criaturas: 0.8,
  passos: 0.5,
  ambiente: 0.5
};

function clamp01(n: number) {
  return Math.min(1, Math.max(0, n));
}

function readStored() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw) as Partial<typeof AUDIO>;
    if (typeof parsed.muted === 'boolean') AUDIO.muted = parsed.muted;
    if (typeof parsed.master === 'number' && Number.isFinite(parsed.master)) AUDIO.master = clamp01(parsed.master);
    for (const c of CANAIS) {
      const v = parsed[c];
      if (typeof v === 'number' && Number.isFinite(v)) AUDIO[c] = clamp01(v);
    }
  } catch {
    /* storage cheio ou JSON ruim — fica o default */
  }
}

readStored();

function persist() {
  try {
    localStorage.setItem(KEY, JSON.stringify(AUDIO));
  } catch {
    /* ignore */
  }
}

export function applyAudio(patch: Partial<typeof AUDIO>) {
  if (patch.muted !== undefined) AUDIO.muted = patch.muted;
  if (patch.master !== undefined) AUDIO.master = clamp01(patch.master);
  for (const c of CANAIS) {
    const v = patch[c];
    if (v !== undefined) AUDIO[c] = clamp01(v);
  }
  persist();
}

export function snapshotAudio() {
  return { ...AUDIO };
}
